import { Icon } from '@/components/icon';
import { notification, Popconfirm, Space } from 'antd';
import { useState, type VFC } from 'react';
import { Button } from 'components';
import { InputNumber } from 'components/form';
import { getMeterApiKeysApiClient } from 'lib/services/inventories/meterApiKeysApi';
import { downloadCSV } from 'lib/utils/downloadCSV';

export const GenerateApiKeysButton: VFC = () => {
  const [apiKeysCount, setApiKeysCount] = useState(1);

  const [isLoading, setIsLoading] = useState(false);

  const handleGenerateApiKeys = (count: number) => {
    setIsLoading(true);
    getMeterApiKeysApiClient()
      .generate(count)
      .then(({ apiKeys }) => {
        downloadCSV<{ apiKey: string }>(
          'meter_api_keys',
          [{ name: 'apiKey', path: 'apiKey' }],
          apiKeys.map((apiKey: string): { apiKey: string } => ({ apiKey })),
        );
      })
      .catch(err => {
        console.error(err);
        notification.warning({
          type: 'warning',
          message: 'An error occurred while generating Meter API keys',
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Button icon={<Icon iconString="download" />} loading={isLoading}>
      <Popconfirm
        cancelText="Cancel"
        okText="Generate and download"
        title={
          <Space>
            <span>Are you sure you want to generate and download</span>
            <InputNumber max={5000} value={apiKeysCount} onChange={value => setApiKeysCount(value)} />
            <span>api keys?</span>
          </Space>
        }
        zIndex={99999}
        onConfirm={() => handleGenerateApiKeys(apiKeysCount)}
      >
        Generate API keys
      </Popconfirm>
    </Button>
  );
};
